import React, { useEffect, useState } from 'react';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import { Visibility } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { wsGetAll } from 'services/WService';
import Table from 'components/Table/Table';
import { useModal } from 'hooks/useModal';
import { formatDate } from 'hooks/Pipe';
import ModalBase from './ModalBase';

function LogDetailModal(props) {
  const { model, setOpen } = props;
  return (
    <ModalBase title="Detalle Log" model={model} setOpen={setOpen} hideSave fullWidth maxWidth="md">
      <GridContainer>
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={6}>
              <h6>Fecha</h6>
              <p>{formatDate(model.created_at)}</p>
            </GridItem>
            <GridItem xs={6}>
              <h6>Usuario</h6>
              <p>{model.user?.name}</p>
            </GridItem>
          </GridContainer>
        </GridItem>
        {!!model.properties?.old && (
          <GridItem xs={6}>
            <h6>Valor antiguo</h6>
            <pre
              style={{
                border: 'solid black 2px',
                borderRadius: '5px',
                overflow: 'auto',
              }}
            >
              {JSON.stringify(model.properties?.old, null, 2)}
            </pre>
          </GridItem>
        )}

        {!!model.properties?.attributes && (
          <GridItem xs={6}>
            <h6>Valor nuevo</h6>
            <pre
              style={{
                border: 'solid black 2px',
                borderRadius: '5px',
                overflow: 'auto',
              }}
            >
              {JSON.stringify(model.properties?.attributes, null, 2)}
            </pre>
          </GridItem>
        )}
      </GridContainer>
    </ModalBase>
  );
}

function LogsModal(props) {
  const { logName, subjectId } = props;
  const { model, setOpen } = props;
  const [logs, setLogs] = useState([]);
  const [detailModel, setDetailOpen] = useModal();

  async function loadLogs() {
    let res = await wsGetAll(`base/activity-log?log_name=${logName}&subject_id=${subjectId}`);
    if (res.success) {
      setLogs(res.data);
    }
  }

  useEffect(() => {
    if (!subjectId) return;
    loadLogs();
  }, [logName, subjectId]);

  return (
    <ModalBase title="Logs" model={model} setOpen={setOpen} hideSave fullWidth maxWidth="sm">
      <LogDetailModal model={detailModel} setOpen={setDetailOpen} fullWidth maxWidth="sm" />
      <GridContainer>
        <GridItem xs={12}>
          <Table
            hover
            tableHeaderColor="warning"
            tableHead={['#', 'Tipo', 'Fecha', 'Usuario', 'Detalles']}
            tableData={logs.map((log, index) => {
              return [
                index + 1,
                log.properties?.old ? 'Actualización' : 'Creación',
                formatDate(log.created_at),
                log.user?.name,
                <RegularButton
                  justIcon
                  round
                  simple
                  color="primary"
                  onClick={() => {
                    console.log(log);
                    setDetailOpen(log);
                  }}
                >
                  <Visibility />
                </RegularButton>,
              ];
            })}
          />
        </GridItem>
      </GridContainer>
    </ModalBase>
  );
}

export default LogsModal;
